// import Styles
import './style.scss';

// import jQuery
import $ from "jquery";

// import Swiper and modules styles
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/parallax';


/* ---------------------------------------------------------------------------------------------------------- */
/* SLIDER DE PAGES */
/* ---------------------------------------------------------------------------------------------------------- */
function wazablockTaxonomySliderInit($block) {

	// Si ACF passe un objet jQuery, on l'utilise directement
	// Sinon on le wrappe
	if (!$block.jquery) {
		$block = $($block);
	}

	if (typeof Swiper !== "undefined" ) {

		let parameters;
		const id = $block.attr('id');
		const slider = $block.find('.swiper')[0];

		let baseParameters = {
			loop: true,
			slidesPerView: 2,
			speed: 1000,

			modules: [Autoplay, Navigation],

			autoplay: {
				enabled: true,
				delay: 2000,
				disableOnInteraction: false,
			},

			navigation: {
				enabled: true,
				prevEl: document.getElementById( id + '-prev'),
				nextEl: document.getElementById( id + '-next'),
			},

			pagination: {
				enabled: false
			},
			scrollbar: {
				enabled: false
			},

			breakpoints: {
				576 : {
					slidesPerView: 3
				},
				768: {
					slidesPerView: 4
				},
				992: {
					slidesPerView: 5
				},
				1200: {
					slidesPerView: 6
				}
			}
		};

		if ( slider ) {

			/* Arguments */
			/* ---------------------------------------------------------------------------------------------------------- */
			if (slider.dataset.parameters != '' && slider.dataset.parameters != undefined) {
				try {
					parameters = JSON.parse(slider.dataset.parameters);
					let modules = [];

					if ( parameters.autoplay && parameters.autoplay.enabled == true ) { modules.push(Autoplay); }
					if (parameters.navigation && parameters.navigation.enabled == true) {
						modules.push(Navigation);
						parameters.navigation.prevEl = '#' + id + '-prev';
						parameters.navigation.nextEl = '#' + id + '-next';
					}
					if ( parameters.pagination && parameters.pagination.enabled == true ) { modules.push(Pagination); }
					if ( parameters.scrollbar && parameters.scrollbar.enabled == true ) { modules.push(Scrollbar); }

					parameters.modules = modules;
				} catch (e) {
					console.log(e);
				}
			}

			parameters = { ...baseParameters, ...parameters };

			// Détruire l'instance existante si elle existe (important pour l'éditeur)
			if (slider.swiper) {
				slider.swiper.destroy(true, true);
			}

			// Petit délai pour s'assurer que le DOM est prêt
			setTimeout(() => {
				try {
					// Lancement du slider
					const swiperInstance = new Swiper('#' + id + ' .swiper', parameters);
					// console.log('Swiper initialized for block:', id, swiperInstance);
				} catch (e) {
					console.error('Error initializing Swiper:', e);
				}
			}, 100);
		}
	}
}

$(() => {
	$('.wazablocks-taxonomy').each(function (i, e) {
		if ($(e).find('.swiper').length) {
			wazablockTaxonomySliderInit($(e));
		}
	});
});

// Initialize dynamic block preview (editor).
if (window.acf) {
	window.acf.addAction('render_block_preview/type=taxonomy', function ($block) {
		// Observer quand le contenu est vraiment là
		const observer = new MutationObserver((mutations, obs) => {
			const slider = $block.find('.swiper');
			if (slider.length) {
				obs.disconnect(); // Arrêter d'observer
				wazablockTaxonomySliderInit($block);
			}
		});

		observer.observe($block[0], {
			childList: true,
			subtree: true
		});

		// Timeout de sécurité
		setTimeout(() => {
			observer.disconnect();
			if ($block.find('.swiper').length) {
				wazablockTaxonomySliderInit($block);
			}
		}, 1000);
	});
}